import { Exception } from '../Exception';

export class OutlookException extends Exception {
  constructor(message: string, error: Office.Error) {
    super(message, error);
  }
}
